/**
 * @generated SignedSource<<08cee26c5d549b39077ab3695468e873>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment$data = {
  readonly dailyDueDateNotification: {
    readonly id: string;
    readonly slackChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment";
};
export type combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment$key = {
  readonly " $data"?: combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "dailyDueDateNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "dailyDueDateNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "slackChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "19821646d7d2d9f665290751c3c840c1";

export default node;
